"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForcedCancellationRefundWording = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../../commonFunctions");
var components_1 = require("@athena-portal/components");
var ForcedCancellationRefundWording = /** @class */ (function (_super) {
    __extends(ForcedCancellationRefundWording, _super);
    function ForcedCancellationRefundWording(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            partyLoaded: false,
            mainCardIdLoaded: false
        };
        return _this;
    }
    ForcedCancellationRefundWording.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getProfile().subscribe(function (output) {
            _this.setState({
                party: output,
                partyLoaded: true
            });
        });
        this.customerPortalService.getPolicyPropertyByPropertyKey(this.props.interaction.agreementNumber, services_1.MAIN_ANNUAL_PAYMENT_CARD).subscribe(function (property) {
            _this.setState({
                mainCardId: property.value,
                mainCardIdLoaded: true
            });
        });
    };
    ForcedCancellationRefundWording.prototype.render = function () {
        var wording;
        var loading = !this.state.partyLoaded || !this.state.mainCardIdLoaded;
        if (!loading) {
            var paymentCard = (0, commonFunctions_1.findMainAnnualPaymentCard)(this.state.party, this.state.mainCardId);
            var last4Digits = paymentCard.cardNumberObfuscated.split('******')[1];
            var premiumToDisplay = this.props.interaction.factors.returnPremium;
            wording = ((0, jsx_runtime_1.jsxs)("div", { className: "policy-cancellation-description", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-blue-1", children: "All done" }), (0, jsx_runtime_1.jsx)("p", { className: "m-0", children: "Your car insurance policy has now been cancelled." }), (0, jsx_runtime_1.jsxs)("p", { className: "mb-4", children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-semi-bold", children: (0, commonFunctions_1.getAmountToDisplay)(premiumToDisplay) }), " has been credited to your card ending ", (0, jsx_runtime_1.jsxs)("span", { className: "font-weight-semi-bold", children: [last4Digits, "."] })] }), (0, jsx_runtime_1.jsx)("p", { children: "Here\u2019s the small print - you have a legal obligation to make sure you\u2019re insured to drive at all times if you use a car in the UK, so you\u2019ll need to arrange alternative cover for your car." })] }));
        }
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!loading && wording, (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: loading })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], ForcedCancellationRefundWording.prototype, "customerPortalService", void 0);
    return ForcedCancellationRefundWording;
}(plugin_journey_1.WidgetBase));
exports.ForcedCancellationRefundWording = ForcedCancellationRefundWording;
//# sourceMappingURL=ForcedCancellationRefundWording.js.map